import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { MultiSelectItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	BlokacePrp: null as boolean | null,
	EantlastexpDat: null as Date | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	ProvozovnaId: null as number | null,
	SkladOzn: null as number | null,
	SkladmistoId: null as number | null,
	SkladmistoIdSkladmisto: null as string | null,
	SkladmistoIdPopis: null as string | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	ZaznamId: null as number | null,
	OrgUnitId: null as number | null,
	DealerKvpsCode: null as string | null,
	OrgUnitText: null as string | null,
	AddressLine: null as string | null,
	City: null as string | null,
	PinCode: null as string | null,
	StatId: null as number | null,
	POShipToWHList: [] as MultiSelectItem[],
	BulkInventoryTime: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		POShipToWHList: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
		[editMutations.SKLAD_MISTO_SELECT_MAPPER](state, { data }) {
			state.edit.SkladmistoId = data.id;
			state.edit.SkladmistoIdSkladmisto = data.value;
			state.edit.SkladmistoIdPopis = data.text;
		},
		[editMutations.DEALERKVPS_SELECT_MAPPER](state, { data }) {
			state.edit.OrgUnitId = data.value;
			state.edit.DealerKvpsCode = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
